// ----------------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//        Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ---------------------------------------------------------------------
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { InstrumentService } from '../core/instrument';
import { StaticProvider } from '../providers/staticProvider';
import { SpzaTelemetryService } from './spzaTelemetry';
export class SpzaInstrumentService extends InstrumentService {
    static getInstance(isClient = true) {
        if (SpzaInstrumentService._instance === null) {
            SpzaInstrumentService._instance = new SpzaInstrumentService(isClient);
        }
        return SpzaInstrumentService._instance;
    }
    static getProvider(isClient = true) {
        return SpzaInstrumentService.getInstance(isClient).getProvider();
    }
    static registerSpzaId(spzaId) {
        return SpzaInstrumentService.getInstance().telemetryService.registerSpzaId(spzaId);
    }
    static registerTrailId(trailId) {
        return SpzaInstrumentService.getInstance().telemetryService.registerTrailId(trailId);
    }
    static registerTenantInfo(oid, tid) {
        return SpzaInstrumentService.getInstance().telemetryService.registerTenantInfo(oid, tid);
    }
    static registerHostType(hostType) {
        return SpzaInstrumentService.getInstance().telemetryService.registerHostType(hostType);
    }
    // Ideally the design should leverage the Add\RemoveProvider and Add\RemoveConsumerServices
    // for this. However, we currently hard code the usage of StaticProvider as well as use
    // probe method directly all over our client code for instrumentation.
    // This will be the cheapest change, with no fall-outs\open issues for now.
    // In future if we add other types of providers, we will anyway need to decouple our dependency
    // on static providers and at the time we can make both client and server explcitly op-into
    // the providers\consumers of their choice.
    static disableInstrumentation() {
        SpzaInstrumentService.getInstance(false);
    }
    constructor(isClient){
        if (SpzaInstrumentService._instance) {
            throw new Error('Error : Instantiation failed. Use SpzaInstrumentService.getInstance');
        } else {
            super(), _define_property(this, "staticProvider", void 0), _define_property(this, "telemetryService", void 0);
            this.name = 'SpzaInstrument';
            this.staticProvider = new StaticProvider('static', this);
            this.telemetryService = new SpzaTelemetryService(this, isClient);
            SpzaInstrumentService._instance = this;
        }
    }
}
_define_property(SpzaInstrumentService, "_instance", null);
